module.exports = __webpack_public_path__ + "static/media/7.5121a930.gif";